import React, { memo } from "react";
import { validators, formats } from "investira.sdk";
import { Stack, useTheme } from "investira.react.components";
const CorrelacaoAtivoTooltip = memo(props => {
  const {
    ativo,
    correlacoes,
    benchmarks
  } = props;
  const theme = useTheme();
  const neutral = theme.palette.background.paper;
  const neg = theme.palette.error.light;
  const pos = theme.palette.primary.main;
  const neutralRgb = parseColorToRgb(neutral);
  const negRgb = parseColorToRgb(neg);
  const posRgb = parseColorToRgb(pos);
  function parseColorToRgb(input) {
    if (!input) return {
      r: 0,
      g: 0,
      b: 0
    };
    if (input.startsWith("#")) {
      let c = input.slice(1);
      if (c.length === 3) c = c.split("").map(ch => ch + ch).join("");
      const num = parseInt(c, 16);
      return {
        r: (num >> 16) & 255,
        g: (num >> 8) & 255,
        b: num & 255
      };
    }
    const m = input.match(/rgba?\((\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
    if (m) return {
      r: +m[1],
      g: +m[2],
      b: +m[3]
    };
    return {
      r: 0,
      g: 0,
      b: 0
    };
  }
  function rgbToCss({
    r,
    g,
    b
  }) {
    return `rgb(${Math.round(r)},${Math.round(g)},${Math.round(b)})`;
  }
  function mixRgb(a, b, t) {
    return {
      r: a.r + (b.r - a.r) * t,
      g: a.g + (b.g - a.g) * t,
      b: a.b + (b.b - a.b) * t
    };
  }
  const getCellColor = value => {
    if (value === null || value === undefined) return rgbToCss(neutralRgb);
    if (value >= 1) return pos;
    if (value <= -1) return neg;
    if (value > 0) return rgbToCss(mixRgb(neutralRgb, posRgb, Math.min(1, value)));
    return rgbToCss(mixRgb(neutralRgb, negRgb, Math.min(1, Math.abs(value))));
  };
  const xAtivoCorrelacoes = correlacoes[ativo.ativo_key];
  return <Stack gap={0.5}>
      {(() => {
      if (!xAtivoCorrelacoes) return null;
      // Ordena as correlações por id, sem mutar o original
      const xCorrelacoesSorted = xAtivoCorrelacoes.slice().sort((xA, xB) => {
        if (xA.correlacao > xB.correlacao) return -1;
        if (xA.correlacao < xB.correlacao) return 1;
        return 0;
      });
      // Agrupa duas a duas
      const xPairs = [];
      for (let xIndex = 0; xIndex < xCorrelacoesSorted.length; xIndex += 2) {
        xPairs.push([xCorrelacoesSorted[xIndex], xCorrelacoesSorted[xIndex + 1] || null // Pode ser undefined se ímpar, então põe null
        ]);
      }
      return xPairs.map((xPair, xPairIndex) => <Stack key={xPairIndex} direction="row" gap={2}>
            {xPair.map((xCorrelacoes, xColIndex) => {
          if (!xCorrelacoes) {
            // Espaço vazio se não houver par
            return <Stack key={xColIndex} flex={1} />;
          }
          const xCorrelacaoValue = xCorrelacoes.correlacao === null || xCorrelacoes.correlacao === undefined ? "---" : xCorrelacoes.correlacao === 1 ? "1" : xCorrelacoes.correlacao === -1 ? "-1" : formats.formatNumber(xCorrelacoes.correlacao, 5);
          const xBenchmark = benchmarks[xCorrelacoes.id].indicador_id;
          return <Stack key={xCorrelacoes.id} direction="row" gap={1} flex={1}
          //   sx={{ minWidth: "100px" }}
          >
                  <Stack flex={1} sx={{
              minWidth: "50px"
            }}>
                    {xBenchmark}
                  </Stack>
                  <Stack id={xCorrelacoes.id} flex={1} sx={{
              minWidth: "50px",
              backgroundColor: getCellColor(xCorrelacoes.correlacao),
              p: 0.5,
              borderRadius: 1,
              textAlign: "right",
              whiteSpace: "nowrap",
              color: validators.isNull(xCorrelacoes.correlacao) ? theme.palette.text.secondary : theme => theme.palette.getContrastText(getCellColor(xCorrelacoes.correlacao))
            }}>
                    {xCorrelacaoValue}
                  </Stack>
                </Stack>;
        })}
          </Stack>);
    })()}
    </Stack>;
});
export default CorrelacaoAtivoTooltip;
